module.exports = __webpack_public_path__ + "assets/img/thumb-Seniors-NZ-Content-Marketing.f0b5a5d3.webp";